module.exports = __webpack_public_path__ + "img/Taco.054b9558.png";